<template>
  <div class="container">
    <div style="display: flex;flex-direction: row;align-items: center;margin-bottom: 10px;">
      <i class="el-icon-s-fold" ></i>
      <el-breadcrumb separator="/" >
        <el-breadcrumb-item >系统服务</el-breadcrumb-item>
        <el-breadcrumb-item >建议反馈</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="equip-add">
      <dv-border-box-12>
        <div style="padding: 6px 6px 8px 6px;">
          <div class="header-common">
            <div class="header-common-left">
              <div class="title">建议反馈</div>
            </div>
          </div>
          <el-form
            :model="form"
              label-width="100px"
              class="add-form"
              :rules="rules"
              ref="form">
              <el-form-item label="意见反馈" prop="suggestion" style="margin-top: 20px;">
                <el-input type="textarea" id="suggestion"  v-model="form.suggestion" :autosize="{ minRows: 8, maxRows: 8}" style="width: 50%;font-size: 15px;"></el-input>
              </el-form-item>
              <el-form-item style="margin-top: 40px;">
                <el-button class="action-button" type="primary"  @click="submitForm('form')">立即保存</el-button>
                <el-button class="action-button" @click="resetForm('form')">重置</el-button>
              </el-form-item>
            </el-form>
        </div>
      </dv-border-box-12>
    </div>
    <div class="equipment-info">
        <div class="header-common">
          <div class="header-common-left">
            <div class="title">我的反馈</div>
          </div>
          <header class="header-common-right" v-if="showActionAll==true">
            <router-link class="right-button-base" :to="{path:'/system/feedback-list'}">
              查看全部
            </router-link>
          </header>
        </div>
        <div class="info-list">
          <el-table
            v-loading='loading'
            :data="tableData"
            border
            :cell-style="tableCellStyle"
            :header-cell-style="tableHeaderCellStyle"
            :max-height="tableHeight"
            >
            <el-table-column
              prop="time"
              label="反馈时间"
              >
            </el-table-column>

            <el-table-column
              prop="suggestion"
              label="反馈内容">
            </el-table-column>
          </el-table>
        </div>
    </div>
  </div>
</template>

<script>
  import {permissionCheckUtil} from '../../utils/permission.js'
  export default {
    data() {
      return {
        showActionAll:false,
        tableData:[],
        loading:false,
        tableHeight:0,
        form: {
          suggestion: ''
        },
        rules: {
          suggestion: [{ required: true, message: '请输入具体的建议或反馈内容', trigger: 'blur' }]
        },
      }
    },
    methods: {
      tableCellStyle() {
        return 'border-color: rgba(0, 255, 255, 0.22);text-align:center;font-size: 14px;font-weight: 400;color: #FEFEFE;'
      },
      tableHeaderCellStyle() {
        return 'border-color: rgba(0, 255, 255, 0.22);background:#021950;text-align:center;font-size: 15px;font-weight: 400;color: #00FFFF;'
      },
      getList(){
        this.loading = true;
        const headers = {
            'Authorization': localStorage.getItem('token')
        }
        const url = '/setting/suggestion/list';

        this.$http({
          method:'GET',
          url:url,
          headers:headers
        }).then(res=>{
          this.loading = false;
          if(res.status == 200){//请求成功
          var obj = res.data;
            if(obj.code == 0){
              if(obj.data.suggestions){
                this.tableData = obj.data.suggestions;
              }
            }else{
              this.$message.error(obj.message);
            }
          }else{
            this.$message.error(res.data.message);
          }

        }).catch(err=>{
          this.loading = false;
          if(!err.response){
            this.$message.error(err.message);
          }else{
            this.$message.error(err.response.data.message);
          }
        })

      },
      toAddSuggestion(){
        const headers = {
            'Authorization': localStorage.getItem('token')
        }
        const url = '/setting/suggestion/add';
        this.$http({
          method:'POST',
          url:url,
          headers:headers,
          data:this.form
        }).then(res=>{
          if(res.status == 200){//请求成功
          var obj = res.data;
            if(obj.code == 0){
              this.$message({
                message:'提交成功',
                type:'success'
              });
              this.resetForm('form');
              this.getList()
            }else{
              this.$message.error(obj.message);
            }
          }else{
            this.$message.error(res.data.message);
          }
        }).catch(err=>{
          if(!err.response){
            this.$message.error(err.message);
          }else{
            this.$message.error(err.response.data.message);
          }
        })
      },
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.toAddSuggestion();
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
      },
      judgePermissions(){
          let feedback = permissionCheckUtil.findName("system:log");

          if(feedback==true){
            this.showActionAll = true;
          }
      },
      sizeFun(){
        this.$nextTick(() => {
          this.tableHeight = window.innerHeight-675 < 300 ? 300 : window.innerHeight-675;
        })
      }
    },
    mounted() {
      window.addEventListener('resize',this.sizeFun)
      this.sizeFun()
      this.getList()
      this.judgePermissions()
    },
    created() {
      
    },
    beforeDestroy() {
      window.removeEventListener('resize',this.sizeFun)
    }
  }
</script>


<style lang="scss" scoped>
  .container {
    height: 100%;
    margin-top: $header-height;

    .header-common{
      width: 100%;
      height: 45px;
      border-radius: 12px 12px 0 0 ;
      background: linear-gradient(-90deg, #001940, #1564BE);
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;

      .header-common-left{

        font-size: 20px;

        font-weight: bold;
        color: #FEFEFE;
        margin-left: 21px;
        .title{
          font-size: 20px;
          font-weight: bold;
          color: #FEFEFE;
        }
      }

      .header-common-right{

        .right-button{
          width: 89px;
          height: 40px;
          background: #FAFAFA;
          border: 1px solid rgba(0,255,96,0.84);
          border-radius: 20px;
          background-color: #208D7F;
          font-size: 14px;
          font-weight: 400;
          color: #00FFB4;
          margin-right: 20px;
        }

        .right-button-base{
          width: 89px;
          height: 40px;
          border: 1px solid rgba(0,144,255,0.84);
          border-radius: 20px;
          background-color: #20478D;
          font-size: 14px;
          font-weight: 400;
          color: #00DEFF;
          margin-right: 20px;
          display: inline-block;
          line-height: 40px;
          text-align: center;
          text-decoration: none;
        }
      }
    }


    .equip-add{

      .add-form{
        padding: 25px 5px 25px 0px;

        .group-box{
          border-radius: 5px;
          border: 1px #20478D solid;
          padding: 10px;
        }
      }

      .content-add-user{
        float: left;
        border-radius: 3px;
      }
      .action-button{
          width: 120px;
          height: 40px;
          background: #FAFAFA;
          border: 1px solid rgba(0,144,255,0.84);
          border-radius: 20px;
          background-color: #20478D;
          font-size: 14px;
          font-weight: 400;
          color: #00DEFF;
      }
    }


    .equipment-info{
      // margin: 0px 6px 20px 6px;
      // height: 100%;
      border: 2px solid #1A3F81;
      border-radius: 12px;
      margin-top: 20px;

      .info-list{
        height: 100%;

        .hander{
          // cursor: pointer;
          color: #fff;
          background-color: #104C90;
          border: 0px;
        }

        .tooltip-back.el-tooltip__popper{
          background-color: red;
        }
      }
    }

  }
</style>



// WEBPACK FOOTER //
// src/view/system/feedback.vue